import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

const defaultProps = {
  className: ''
};

export default class LeftRail extends Component {
  render() {
    const classes = [this.props.className, 'rec-grid-8-12'].filter((v) => v !== "").join(' ');

    return (
      <aside className={classes}>
        {this.props.children}
      </aside>
    );
  }
}

LeftRail.propTypes = propTypes;
LeftRail.defaultProps = defaultProps;
